export const ADD_ERROR_MESSAGE = '[message] Add error message' as const;
export const ADD_SUCCESS_MESSAGE = '[message] Add success message' as const;
export const REMOVE_MESSAGE = '[message] Remove message' as const;
